import Endpoints from 'constants/Endpoints';
import {clearResource, setResource} from 'redux/actions'
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import applySearchParams from "libs/applySearchParams";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";

const CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID = 'contractorVerificationList';
const CONTRACTOR_VERIFICATION_PROCEDURE_RESOURCE_ID = 'contractorVerificationProcedure';

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
}

const getContractors = async (roundId, pagination, search) => {
    const params = {
        ...pagination
    };
    applySearchParams(search, params);
    try {
        const res = await RestRequestGET(Endpoints.CONTRACTOR_VERIFICATION_LIST(roundId), {params});
        let res2;
        if (pagination.page > 1) {
            const state = reduxStore.getState();
            if (state?.resources?.[CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID]?.items) {
                res2 = {
                    ...res,
                    items: [...state.resources[CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID].items, ...res.items],
                };
            }
        } else {
            res2 = res;
        }
        reduxStore.dispatch(setResource(CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID, res2));
    } catch (error) {
    }
};

const updateContractorStatus = async (demandId, contractor, status) => {
    try {
        const resp = await RestRequestPOST(Endpoints.CONTRACTOR_VERIFICATION_STATUS(demandId), {contractor, status});
        if (resp.success) {
            const state = reduxStore.getState();
            if (state?.resources?.[CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID]?.items) {
                const curRes = state.resources[CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID];
                const res = {
                    ...curRes,
                    items: curRes.items.map(x => x.contractor.identity === contractor.identity ? {...x, status} : x)
                }
                reduxStore.dispatch(setResource(CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID, res))
            }
            await validateSection(DemandValidation.CONTRACTOR_VERIFICATION, demandId, false);
            await validateSection(DemandValidation.OFFERS_EVALUATION, demandId, false);
            await validateSection(DemandValidation.OFFER_CHOICE, demandId, false);
        }
    } catch (error) {
    }
}

const getProcedure = async (id) => {
    try {
        const resp = await RestRequestGET(Endpoints.CONTRACTOR_VERIFICATION_PROCEDURE(id));
        reduxStore.dispatch(setResource(CONTRACTOR_VERIFICATION_PROCEDURE_RESOURCE_ID, resp));
    } catch (error) {
    }
};

const updateProcedure = async (demandId, verificationProcedure) => {
    try {
        const resp = await RestRequestPOST(Endpoints.CONTRACTOR_VERIFICATION_PROCEDURE(demandId), {verificationProcedure});
        reduxStore.dispatch(setResource(CONTRACTOR_VERIFICATION_PROCEDURE_RESOURCE_ID, resp));
        await validateSection(DemandValidation.CONTRACTOR_VERIFICATION, demandId, false);
        await validateSection(DemandValidation.OFFERS_EVALUATION, demandId, false);
        await validateSection(DemandValidation.OFFER_CHOICE, demandId, false);
    } catch (error) {
    }
}

const validate = async (id) => {
    return RestRequestGET(Endpoints.CONTRACTOR_VERIFICATION_VALIDATE(id));
}

export default {
    getContractors,
    updateContractorStatus,
    getProcedure,
    updateProcedure,
    validate,
    clearResources,
    CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID,
    CONTRACTOR_VERIFICATION_PROCEDURE_RESOURCE_ID
}